import {
  GET_COMPANIES,
  ADD_COMPANY,
  UPDATE_COMPANY,
  DELETE_COMPANY,
  REQUEST_COMPANY,
  REQUEST_COMPANY_GET,
  ERROR_XHR
} from '../mutation-types'

import toastr from 'toastr'

const state = {
  all: [],
  company: {},
  error: false
}

const mutations = {
  [GET_COMPANIES] (state, companies) {
    state.all = companies
  },
  [ADD_COMPANY] (state, company) {
    state.all.push(company)
    toastr.success('L\'entreprise a été créée')
  },
  [UPDATE_COMPANY] (state, oldCompany, updatedCompany) {
    state.all.$remove(oldCompany)
    state.all.push(updatedCompany)
    toastr.success('L\'entreprise a été modifiée')
  },
  [DELETE_COMPANY] (state, company) {
    state.companyDeleted = true
    state.all.$remove(company)
    toastr.success('L\'entreprise a été supprimée')
  },
  [REQUEST_COMPANY_GET] (state) {
    state.all = []
    state.error = false
  },
  [REQUEST_COMPANY] (state) {
    state.error = false
  },
  [ERROR_XHR] (state, error) {
    console.log(state)
    console.log(error)
    state.error = true
    toastr.error(error)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/companies.js